.validation-error__container {
  position: absolute;

  display: flex;
  flex-flow: row nowrap;

  white-space: nowrap;

  // margin-top: -4px;
}
